export default class RequestRepeatError extends Error {
  constructor(reason: string) {
    super(reason)
    this.name = 'RequestRepeatError'
  }
}
